<template>
  <div class="content-tab live-update">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading" :style="{position: 'fixed'}"/>
    <div class="content-body">
      <div class="table-row">
        <div class="title">{{$t('overview.modelname')}}</div>
        <div :title="sysBoard.Product" class="value" v-if="sysBoard">{{sysBoard.Product}}</div>
      </div>
      <div class="table-row">
        <div class="title">{{$t('updatefw.fwVersion')}}</div>
        <div :title="fwinfo.version+'.'+fwinfo.number" class="value" v-if="fwinfo">{{fwinfo.version+'.'+fwinfo.number}}</div>
      </div>
      <div class="table-row">
        <div class="title">{{$t('updatefw.date')}}</div>
        <div :title="fwinfo.date" class="value" v-if="fwinfo">{{fwinfo.date}}</div>
      </div>
      <div class="table-row">
        <div class="title">{{$t('updatefw.systemuptime')}}</div>
        <div :title="UpTime" class="value" v-if="displayTime">{{displayTime}}</div>
      </div>
      <button class="q-button blue-btn-full footer-btn" :title="$t('updatefw.checkupdate')" @click="onCheckClick">{{$t('updatefw.checkupdate')}}</button>
    </div>
    <popup-confirm name="firmware-modal" :dialog-header="$t('updatefw.updatesystem')" :dialog-message="modalContent1" icon="w" type="u" :callback="goUpdate" :onlyOk="!modalFootBtn" />
    <popup-confirm :selHeight="160" name="warn-modal" :dialog-header="$t('updatefw.updateFail')" :onlyOk=true />
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'
export default {
  name: 'live-update',
  data () {
    return {
      filename: this.$t('updatefw.selectfile'),
      UpTime: null,
      liveFW: null,
      test: true,
      haveDNS: false,
      isShowLoading: false
    }
  },
  created: async function () {
    let me = this
    window.addEventListener('beforeunload', function (e) {
      me.firmwareUpdateExit()
    })
    this.getDNSConfig()
      .then((response) => {
        if (response.data.result && response.data.result.length > 0) {
          let tempList = response.data.result
          let result = false
          if (tempList[0].val.IpAddress !== '') {
            result = true
          }
          this.haveDNS = result
        } else {
          this.haveDNS = false
        }
      })
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    ...mapMutations(['openModal', 'closeModal']),
    ...mapActions(['getSystemUptime', 'getSystemInfo', 'postLiveUpload', 'checkLiveUpdate', 'getDNSConfig', 'firmwareUpdateExit']),
    getInfo () {
      let me = this
      this.getSystemUptime()
        .then((res) => {
          if (res.data && res.data.error_code === 200) {
            me.UpTime = res.data.result.UpTime // sec
          }
        })
    },
    onCheckClick () {
      this.isShowLoading = true
      if (this.haveDNS) {
        this.checkLiveUpdate()
          .then((res) => {
            if (res && res.data.error_code === 200) {
              this.isShowLoading = false
              this.liveFW = res.data.result
              this.openModal('firmware-modal')
              this.$modal.show('firmware-modal')
            }
          }).catch((error) => {
            this.isShowLoading = false
            this.$log.error(error)
            this.$store.commit('setErrorWin', {
              show: true,
              data: (error.response.data) ? error.response.data : error.response,
              config: error.config,
              title: null
            })
            // this.$modal.show('warn-modal')
            // this.openModal('warn-modal')
          })
      } else {
        this.isShowLoading = false
        this.$store.commit('setErrorWin', {
          show: true,
          data: {
            error_code: 5,
            error_message: 'Dns error from FE.',
            result: null,
            title: this.$t('warning')
          },
          config: {}
        })
      }
    },
    goUpdate () {
      this.closeModal('firmware-modal')
      this.$modal.hide('firmware-modal')
      this.$store.commit('setUpdateStatus', true)
      this.$store.commit('updateFileStatus', false)
      this.$store.commit('setUpdateType', 'live')
      this.postLiveUpload()
        .then((res) => {
          this.$log.debug(res)
        }).catch((error) => {
          this.$log.error(error)
        })
    }
  },
  computed: {
    ...mapGetters({}),
    ...mapState({
      sysBoard: state => state.module.sysBoard,
      fwinfo: state => state.module.fwinfo
    }),
    modalTitle () {
      return this.$t('menu.firmwareupdate')
    },
    modalContent1 () {
      let isNew = (this.liveFW) ? this.liveFW.newer : false
      let result = (isNew) ? this.$t('updatefw.updateContent', {'version': this.liveFW.version}) + '.' + this.liveFW.number + ' ' + '(' + this.liveFW.buildNumber + ')' : this.$t('updatefw.alreadyUpdate')
      return result
    },
    modalFootBtn () {
      let isNew = (this.liveFW) ? this.liveFW.newer : false
      return isNew
    },
    displayTime () {
      let sec = (this.UpTime) ? this.UpTime : '--'
      let time = sec + ' ' + this.$t('timestamp.sec')
      if (sec > 60) {
        var second = parseInt(sec) % 60
        var min = parseInt(sec / 60)
        time = min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
        if (min > 60) {
          min = parseInt(sec / 60) % 60
          var hour = parseInt(parseInt(sec / 60) / 60)
          time = hour + ' ' + this.$t('timestamp.hour') + ' ' + min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
          if (hour > 24) {
            hour = parseInt(parseInt(sec / 60) / 60) % 24
            var day = parseInt(parseInt(parseInt(sec / 60) / 60) / 24)
            time = day + ' ' + this.$t('timestamp.day') + ' ' + hour + ' ' + this.$t('timestamp.hour') + ' ' + min + ' ' + this.$t('timestamp.min') + ' ' + second + ' ' + this.$t('timestamp.sec')
          }
        }
      }
      return time
    }
  }
}
</script>

<style lang="scss" scoped>
.content-tab.live-update {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-body {
    padding: 20px 20px 0px 20px;
    .table-row {
      padding-bottom: 10px;
      display: flex;
      justify-content: flex-start;
      .title {
        font-family: 'Roboto-M' !important;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LiveUpdate.vue